module.exports = __webpack_public_path__ + "static/media/service_advanced.d7a2c9e7.png";